<template>
    <div style="overflow: auto">
        <div v-if="dettaglio" class="card sa-siat-card-pratica shadow-sm">
            <div class="sa-siat-card-header-custom">
                <b-row class="align-items-center">
                    <b-col cols="12" md="4">
                        <div class="sa-siat-label-pai">Assistito</div>
                        <div class="h5 mb-0 text-primary">{{ dettaglio.cognomeAssistito }} {{ dettaglio.nomeAssistito }}</div>
                        <small class="text-muted"><i class="fas fa-map-marker-alt"></i> {{ dettaglio.indirizzoVia }} - {{ dettaglio.indirizzoCitta }}</small>
                    </b-col>
                    <b-col cols="12" md="4">
                        <div class="sa-siat-label-pai">Codice Fiscale</div>
                        <span class="sa-siat-data">{{ dettaglio.codiceFiscaleAssistito }}</span>
                        <div class="sa-siat-label-pai mt-2">Telefono / Email</div>
                        <span>{{ dettaglio.telefonoAssistito || "-" }} / {{ dettaglio.emailAssistito || "-" }}</span>
                    </b-col>
                    <b-col cols="12" md="4">
                        <div class="sa-siat-label-pai">Stato Piano</div>
                        <span class="badge badge-pill badge-light border sa-siat-badge" :class="'sa-siat-badge-' + (paiAttivo ? 'aperta' : 'da-programmare')">{{ dettaglio.status }}</span>
                        <div v-if="!paiAttivo" class="text-danger small mt-1"><i class="fas fa-lock"></i> PAI non attivo: erogazione disabilitata</div>
                        <div class="sa-siat-label-pai mt-2">Periodo</div>
                        <span>{{ formatDate(dettaglio.periodStart) }} - {{ formatDate(dettaglio.periodEnd) }}</span>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col cols="12" md="4">
                        <div class="sa-siat-label-pai">Ambito / Livello / Tipo ADI</div>
                        <div>{{ dettaglio.ambitoAdiDisplay }} / {{ dettaglio.livelloAdiDisplay }} / {{ dettaglio.tipoAdiDisplay }}</div>
                    </b-col>
                    <b-col cols="12" md="4">
                        <div class="sa-siat-label-pai">Distretto Autore</div>
                        <div>{{ dettaglio.codiceAslAutore }}</div>
                    </b-col>
                    <b-col cols="12" md="4">
                        <div class="sa-siat-label-pai">Medico di Base</div>
                        <div>{{ dettaglio.medicoBaseCognome }} {{ dettaglio.medicoBaseNome }} ({{ dettaglio.medicoBaseCf }})</div>
                    </b-col>
                </b-row>
            </div>

            <!-- Storico stati -->
            <div class="pb-3 pt-2 bg-light">
                <div class="px-4 mb-2 small font-weight-bold text-muted text-uppercase">Storico Stati:</div>
                <div class="px-4">
                    <b-table v-if="eventi.length" :items="eventiOrdinati" :fields="fieldsEventi" small striped>
                        <template #cell(dataRilevante)="{ item }">
                            {{ formatDate(dataPerTipoEvento(item)) }}
                            <small v-if="item.tipoEvento === 'Sospensione' && item.motivoSospensione" class="text-muted d-block">Motivo: {{ item.motivoSospensione }}</small>
                        </template>
                    </b-table>
                    <div v-else class="text-muted">Nessuno storico disponibile</div>
                </div>
            </div>

            <!-- Care team -->
            <div class="pb-3 pt-2">
                <div class="px-4 mb-2 small font-weight-bold text-muted text-uppercase">Care Team:</div>
                <div class="px-4" v-if="careTeam.length">
                    <span v-for="ct in careTeam" :key="ct.id" class="mr-3">
                        <span class="badge badge-outline-secondary">{{ ct.ruoloDisplay || ct.ruoloCode }}</span>
                        {{ ct.operatoreDisplay || ct.operatoreIdentificativo || "-" }}
                    </span>
                </div>
                <div v-else class="px-4 text-muted">Nessun care team disponibile</div>
            </div>

            <!-- Prestazioni + erogazione -->
            <div class="pb-3 pt-2 bg-light">
                <!-- <div class="px-4 mb-2 d-flex justify-content-between align-items-center">
                    <span class="small font-weight-bold text-muted text-uppercase">Prestazioni:</span>
                    <b-button v-if="paiAttivo" size="sm" variant="success" @click="onClickRegistraErogazione">
                        <i class="fas fa-check-circle"></i>
                        Registra Erogazione ({{ numeroSelezionate }} selezionat{{ numeroSelezionate === 1 ? "a" : "e" }})
                    </b-button>
                </div> -->

                <b-table :items="prestazioniSelezionabili" :fields="fieldsPrestazioni" small striped>
                    <template #cell(sel)="{ item }">
                        <b-form-checkbox v-if="paiAttivo && !item.erogata" v-model="item.selezionata" />
                        <div v-else-if="item.erogata">
                            <span class="badge badge-success">Erogata</span>
                            <div v-if="item.dettaglioErogazione" class="small text-muted mt-1" style="max-width: 180px">
                                {{ formatDateTime(item.dettaglioErogazione.dataOraInizio) }}<br />
                                Op: {{ item.dettaglioErogazione.codiceFiscaleOperatore }}<br />
                                Acc: {{ item.dettaglioErogazione.codiceAccesso }}
                            </div>
                        </div>
                        <span v-else class="text-muted">-</span>
                    </template>
                    <template #cell(prestazione)="{ item }">
                        <span class="badge badge-outline-secondary mr-1">{{ item.codicePrestazione }}</span>
                        {{ item.descrizionePrestazione }}
                    </template>
                    <template #cell(frequenza)="{ item }">{{ formatFrequenza(item.frequenza, item.periodo, item.periodUnit) }}</template>

                    <template #cell(figura)="{ item }">{{ formatFiguraProfessionale(item.performer[0].figuraProfessionaleCode) }}</template>
                </b-table>
                <div v-if="!prestazioniSelezionabili.length" class="px-4 text-muted">Nessuna prestazione disponibile</div>
            </div>

            <!-- Eventi (notifiche PAI, come nella pagina Eventi) -->
            <div class="pb-3 pt-2">
                <div class="px-4 mb-2 d-flex justify-content-between align-items-center">
                    <span class="small font-weight-bold text-muted text-uppercase">Eventi (notifiche):</span>
                    <b-button size="sm" variant="outline-info" @click="onClickRicaricaEventiPai">
                        <i class="fas fa-sync"></i>
                        Ricarica
                    </b-button>
                </div>
                <b-table v-if="eventiPai.length" :items="eventiPai" :fields="fieldsEventiPai" small striped>
                    <template #cell(dataRilevante)="{ item }">
                        {{ formatDate(dataPerTipoEvento(item)) }}
                    </template>
                    <template #cell(statoLettura)="{ item }">
                        <span v-if="item.statoLettura === 'LETTO'" class="badge badge-success">LETTO</span>
                        <span v-else class="badge badge-warning">DA LEGGERE</span>
                    </template>
                    <template #cell(actions)="{ item }">
                        <b-button v-if="item.statoLettura !== 'LETTO'" size="sm" variant="outline-info" @click="onClickPrendiInCaricoEvento(item)">
                            <i class="fas fa-hand-holding-medical"></i>
                            Presa in carico
                        </b-button>
                    </template>
                </b-table>
                <div v-else class="px-4 text-muted">Nessun evento locale per questo PAI</div>
            </div>

            <!-- Accessi (recupero da AnDIamo) -->
            <div class="pb-3 pt-2 bg-light">
                <div class="px-4 mb-2 d-flex justify-content-between align-items-center">
                    <span class="small font-weight-bold text-muted text-uppercase">Accessi:</span>
                </div>
                <b-row class="px-4 mb-2">
                    <b-col cols="12" md="3">
                        <label class="sa-label-data">Stato</label>
                        <b-form-select v-model="filtroAccessi.stato" :options="opzioniStatoAccesso" size="sm" />
                    </b-col>
                    <b-col cols="12" md="3">
                        <label class="sa-label-data">Data Da</label>
                        <date-picker format="YYYY-MM-DD" value-type="format" type="date" v-model="filtroAccessi.dataDa"></date-picker>
                    </b-col>
                    <b-col cols="12" md="3">
                        <label class="sa-label-data">Data A</label>
                        <date-picker format="YYYY-MM-DD" value-type="format" type="date" v-model="filtroAccessi.dataA"></date-picker>
                    </b-col>
                    <b-col cols="12" md="3" class="d-flex align-items-end">
                        <b-button size="sm" variant="outline-info" @click="onClickRecuperaAccessi">
                            <i class="fas fa-cloud-download-alt"></i>
                            Recupera Accessi da AnDIamo
                        </b-button>
                    </b-col>
                </b-row>
                <b-table v-if="accessiPai.length" :items="accessiArricchitiPerErogazione" :fields="fieldsAccessiPai" small striped>
                    <template #cell(stato)="{ item }">
                        <span class="badge badge-pill badge-light border" :class="'sa-siat-badge-' + (item.stato === 'finished' ? 'aperta' : 'da-programmare')">{{ item.stato }}</span>
                    </template>
                    <template #cell(periodo)="{ item }">{{ formatDateTime(item.dataOraInizio) }}</template>
                    <template #cell(frequenzaDettaglio)="{ item }">
                        <span v-if="item.frequenzaDettaglio" class="small">{{ item.frequenzaDettaglio }}</span>
                        <span v-else class="text-muted small">-</span>
                    </template>
                    <template #cell(prestazioni)="{ item }">
                        <div v-if="item.prestazioniCollegate.length">
                            <div v-for="p in item.prestazioniCollegate" :key="p.id" class="mb-1">
                                <b-form-checkbox v-if="!p.erogata && !p.bloccoMotivo" v-model="selezioneAccessi[item.id]" :value="p.id">
                                    <span class="badge badge-outline-secondary mr-1">{{ p.codicePrestazione }}</span>
                                    {{ p.descrizionePrestazione }}
                                    <small v-if="trovaAttivitaCollegata(item, p)" class="text-muted d-block">
                                        {{ formatFrequenza(trovaAttivitaCollegata(item, p).frequenza, trovaAttivitaCollegata(item, p).periodo, trovaAttivitaCollegata(item, p).periodUnit) }}
                                        — {{ trovaAttivitaCollegata(item, p).minutaggio }} min — {{ formatFiguraProfessionale(trovaAttivitaCollegata(item, p).figuraProfessionaleCode) }}
                                    </small>
                                </b-form-checkbox>
                                <div v-else>
                                    <span class="badge badge-outline-secondary mr-1">{{ p.codicePrestazione }}</span>
                                    {{ p.descrizionePrestazione }}
                                    <span v-if="p.erogata" class="badge badge-success ml-1">Erogata</span>
                                    <span v-else-if="p.bloccoMotivo" class="badge badge-danger ml-1" :title="p.bloccoMotivo"><i class="fas fa-lock"></i> Bloccata</span>
                                    <div v-if="p.erogata && p.dettaglioErogazione" class="small text-muted">{{ formatDateTime(p.dettaglioErogazione.dataOraInizio) }} — Op: {{ p.dettaglioErogazione.codiceFiscaleOperatore }} — Acc: {{ p.dettaglioErogazione.codiceAccesso }}</div>
                                </div>
                            </div>
                        </div>
                        <span v-else class="text-muted small">Nessuna prestazione collegata</span>
                    </template>
                    <template #cell(azioni)="{ item }">
                        <b-button v-if="item.erogabile" size="sm" variant="success" :disabled="!(selezioneAccessi[item.id] && selezioneAccessi[item.id].length)" @click="onClickErogaAccessoPai(item)">
                            <i class="fas fa-check-circle"></i>
                            Eroga ({{ selezioneAccessi[item.id] ? selezioneAccessi[item.id].length : 0 }}/{{ item.prestazioniCollegate.length }})
                        </b-button>
                        <span v-else-if="item.stato === 'planned'" class="text-muted small">Non ancora erogabile</span>
                    </template>
                </b-table>
                <div v-else class="px-4 text-muted">Nessun accesso locale: usa "Recupera Accessi da AnDIamo"</div>
            </div>
        </div>
        <no-data-component v-else title="Nessun dettaglio locale per questo PAI: aggiornalo da AnDIamo" :fontSize="15" :paddingSize="0.5" />

        <AndiamoErogazioneModalComponent ref="modalErogazione" :dettaglio="dettaglio" @registrata="onErogazioneRegistrata" />
    </div>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import AndiamoMixin from "../mixins/AndiamoMixin";
import NoDataComponent from "../../../template/components/utility/NoDataComponent.vue";
import AndiamoErogazioneModalComponent from "./AndiamoErogazioneModalComponent.vue";

export default {
    components: { NoDataComponent, AndiamoErogazioneModalComponent, DatePicker },
    mixins: [AndiamoMixin],
    data() {
        return {
            idPai: null,
            codiceAsl: null,
            dettaglio: null,
            attivita: [],
            careTeam: [],
            diagnosi: [],
            eventi: [],
            eventiPai: [],
            accessiPai: [],
            filtroAccessi: {
                stato: "planned",
                dataDa: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
                dataA: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
            },
            opzioniStatoAccesso: [
                { value: null, text: "Tutti" },
                { value: "planned", text: "planned" },
                { value: "finished", text: "finished" },
                { value: "cancelled", text: "cancelled" },
            ],
            erogazioniEsistenti: [],
            fieldsEventiPai: [
                { key: "idEvento", label: "idEvento" },
                { key: "tipoEvento", label: "Tipo" },
                { key: "dataRilevante", label: "Data" },
                { key: "statoLettura", label: "Stato" },
                { key: "actions", label: "" },
            ],
            fieldsAccessiPai: [
                { key: "codiceAccesso", label: "Codice Accesso" },
                { key: "stato", label: "Stato" },
                { key: "periodo", label: "Periodo" },
                { key: "frequenzaDettaglio", label: "Attività (frequenza)" },
                { key: "prestazioni", label: "Prestazioni" },
                { key: "azioni", label: "" },
            ],
            prestazioniPerAccesso: {},
            selezioneAccessi: {},
            fieldsEventi: [
                { key: "tipoEvento", label: "Tipo Evento" },
                { key: "dataRilevante", label: "Data" },
                { key: "idEvento", label: "idEvento" },
            ],
            fieldsPrestazioni: [
                { key: "sel", label: "" },
                { key: "prestazione", label: "Prestazione" },
                { key: "frequenza", label: "Frequenza" },
                { key: "figura", label: "Figura Prof." },
                { key: "stato", label: "Stato Attività" },
            ],
        };
    },
    computed: {
        paiAttivo() {
            return this.dettaglio && this.dettaglio.status === "active";
        },
        /**
         * Arricchisce ogni accesso con le sue prestazioni collegate (da
         * gesan_andiamo_accessi_prestazioni) e con l'idoneita' a erogazione
         * (stato planned + data <= oggi). Inizializza la selezione checkbox
         * a "tutte spuntate" (erogazione completa di default).
         */
        accessiArricchitiPerErogazione() {
            let oggi = new Date();
            oggi.setHours(0, 0, 0, 0);
            return [...this.accessiPai]
                .sort((a, b) => new Date(a.dataOraInizio) - new Date(b.dataOraInizio))
                .map((acc) => {
                    let prestazioniCollegate = (this.prestazioniPerAccesso[acc.id] || []).map((p) => {
                        let idPeiRiferimento = p.idPei || acc.idPei;
                        let dettaglioErogazione = this.erogazioniEsistenti.find((erg) => erg.codiceAccesso === acc.codiceAccesso);
                        return {
                            ...p,
                            erogata: !!dettaglioErogazione,
                            dettaglioErogazione: dettaglioErogazione || null,
                            bloccoMotivo: this.calcolaBloccoPerPei(idPeiRiferimento, acc.dataOraInizio),
                        };
                    });
                    let dataAccesso = acc.dataOraInizio ? new Date(acc.dataOraInizio) : null;
                    let erogabile = acc.stato === "planned" && dataAccesso && dataAccesso <= oggi;
                    if (this.selezioneAccessi[acc.id] === undefined) {
                        this.$set(
                            this.selezioneAccessi,
                            acc.id,
                            prestazioniCollegate.filter((p) => !p.erogata && !p.bloccoMotivo).map((p) => p.id),
                        );
                    }
                    let attivitaCollegata = this.attivita.find((a) => a.attivita && a.attivita.codiceInterno === acc.idActivity);
                    let frequenzaDettaglio = attivitaCollegata ? this.formatFrequenza(attivitaCollegata.attivita.frequenza, attivitaCollegata.attivita.periodo, attivitaCollegata.attivita.periodUnit) : null;
                    return { ...acc, prestazioniCollegate, erogabile, attivitaCollegata: attivitaCollegata ? attivitaCollegata.attivita : null, frequenzaDettaglio };
                });
        },
        eventiOrdinati() {
            return [...this.eventi].sort((a, b) => (a.dataEvento < b.dataEvento ? 1 : -1));
        },
        prestazioniSelezionabili() {
            return this.attivita.map((att) => {
                let dettaglioErogazione = this.erogazioniEsistenti.find((erg) => erg.codicePrestazione === att.attivita.codicePrestazione && erg.idPei === att.attivita.idPei);
                return {
                    ...att.attivita,
                    performer: att.performer,
                    erogata: !!dettaglioErogazione,
                    dettaglioErogazione: dettaglioErogazione || null,
                    selezionata: false,
                };
            });
        },
        numeroSelezionate() {
            return this.prestazioniSelezionabili.filter((p) => p.selezionata).length;
        },
    },
    mounted() {
        this.idPai = this.$route.params.idPai;
        this.codiceAsl = this.$route.query.codiceAsl || null;
        this.loadData();
    },
    methods: {
        loadData() {
            if (!this.idPai) {
                return;
            }
            this.andiamoCaricaDettaglioPaiLocale(this.idPai, this.onLoadDettaglioSuccess);
            this.loadEventiPai();
            this.loadAccessiPai();
        },
        /**
         * Eventi (notifiche) locali per questo PAI, con azione "Presa in
         * carico" - stessa fonte dati e stessa azione della pagina Eventi
         * PAI, filtrata pero' per idPai invece di essere per ASL.
         */
        loadEventiPai() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.andiamoPaiLocaliPathResource;
            axios
                .get(link, { params: { idPai: me.idPai } })
                .then((response) => {
                    me.eventiPai = response.data.data.list || [];
                })
                .catch(() => {});
        },
        /**
         * Blocco erogazione per un singolo PEI (gli eventi Sospensione/
         * Riattivazione/Modifica PEI sono specifici per idPei, CONFERMATO
         * su dato reale - non vanno applicati a tutto il PAI indistintamente).
         * Restituisce il motivo del blocco (stringa) o null se erogabile.
         * - Sospensione: blocca dataSospensione in poi, a meno che non ci sia
         *   una Riattivazione successiva con dataRiattivazione <= data
         *   dell'accesso.
         * - Modifica PEI: non ha una data dedicata (solo dataEvento, il
         *   momento della notifica) - blocca tutto cio' che e' PRIMA di
         *   quella data, perche' da quel momento il PEI ha nuove prestazioni
         *   e la programmazione precedente potrebbe non essere piu' valida.
         */
        calcolaBloccoPerPei(idPei, dataOraInizioAccesso) {
            if (!idPei || !dataOraInizioAccesso) {
                return null;
            }
            let dataAccesso = new Date(dataOraInizioAccesso);
            let eventiPei = this.eventi.filter((e) => e.idPei === idPei);

            let sospensioni = eventiPei.filter((e) => e.tipoEvento === "Sospensione" && e.dataSospensione).map((e) => new Date(e.dataSospensione));
            let riattivazioni = eventiPei.filter((e) => e.tipoEvento === "Riattivazione" && e.dataRiattivazione).map((e) => new Date(e.dataRiattivazione));
            for (let inizioSospensione of sospensioni) {
                if (dataAccesso < inizioSospensione) {
                    continue;
                }
                let riattivatoPrimaDellAccesso = riattivazioni.some((r) => r >= inizioSospensione && r <= dataAccesso);
                if (!riattivatoPrimaDellAccesso) {
                    return "PAI sospeso dal " + inizioSospensione.toLocaleDateString("it-IT");
                }
            }

            let modifichePei = eventiPei.filter((e) => e.tipoEvento === "Modifica PEI" && e.dataEvento).map((e) => new Date(e.dataEvento));
            if (modifichePei.length) {
                let ultimaModifica = new Date(Math.max(...modifichePei));
                if (dataAccesso < ultimaModifica) {
                    return "PEI modificato il " + ultimaModifica.toLocaleDateString("it-IT") + ": erogabile solo da quella data";
                }
            }

            return null;
        },
        onClickRicaricaEventiPai() {
            this.loadEventiPai();
        },
        /**
         * Registra l'erogazione per le prestazioni spuntate di QUESTO
         * accesso specifico (checkbox in selezioneAccessi[acc.id]), usando
         * il suo vero codiceAccesso AnDIamo.
         */
        /**
         * Collega una prestazione erogabile (da gesan_andiamo_accessi_prestazioni)
         * alla sua "attivita'" prevista dal PAI (gesan_andiamo_pai_attivita),
         * per mostrare frequenza/minutaggio/figura professionale. Il join e'
         * doppio: prima per idActivity (= codiceInterno, l'accesso/visita),
         * poi per codicePrestazione (dato che una stessa attivita' puo'
         * avere piu' prestazioni, dopo il fix "prestazioni multiple" - senza
         * il secondo match si rischia di prendere la prestazione sbagliata
         * tra quelle della stessa attivita').
         */
        trovaAttivitaCollegata(acc, prestazione) {
            if (!acc.idActivity || !this.attivita.length) {
                return null;
            }
            let match = this.attivita.find((a) => a.attivita && a.attivita.codiceInterno === acc.idActivity && a.attivita.codicePrestazione === prestazione.codicePrestazione);
            return match ? match.attivita : null;
        },
        onClickErogaAccessoPai(acc) {
            let idSelezionati = this.selezioneAccessi[acc.id] || [];
            let prestazioniSelezionate = acc.prestazioniCollegate.filter((p) => idSelezionati.includes(p.id));
            if (!prestazioniSelezionate.length) {
                this.$bvToast.toast("Seleziona almeno una prestazione", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            this.$refs.modalErogazione.apri(prestazioniSelezionate, acc);
        },
        /**
         * Sceglie la data "giusta" in base al tipo di evento, invece di
         * mostrare sempre il generico dataEvento (il timestamp della sola
         * notifica, non il dato utile all'operatore):
         * - Sospensione -> dataSospensione (quando il piano risulta sospeso)
         * - Riattivazione -> dataRiattivazione
         * - qualunque altro tipo -> dataEvento
         * Usato sia per "Storico Stati" (array eventi, che ha gia' questi
         * campi) sia per "Eventi (notifiche)" (array eventiPai, che non li
         * ha: qui si fa cross-reference con "eventi" tramite lo stesso
         * idEvento, condiviso da entrambe le fonti).
         */
        dataPerTipoEvento(item) {
            let sorgente = item;
            if (item.dataSospensione === undefined && item.dataRiattivazione === undefined) {
                let storico = this.eventi.find((e) => e.idEvento === item.idEvento);
                if (storico) {
                    sorgente = storico;
                }
            }
            if (item.tipoEvento === "Sospensione" && sorgente.dataSospensione) {
                return sorgente.dataSospensione;
            }
            if (item.tipoEvento === "Riattivazione" && sorgente.dataRiattivazione) {
                return sorgente.dataRiattivazione;
            }
            return sorgente.dataEvento || item.dataEvento;
        },
        onClickPrendiInCaricoEvento(evento) {
            let codiceAslDaUsare = this.codiceAsl || evento.codiceAsl;
            this.andiamoConfermaPresaInCarico(evento, codiceAslDaUsare, () => {
                this.$bvToast.toast("Presa in carico confermata", { title: "", variant: "success", solid: true });
                this.loadEventiPai();
            });
        },
        /**
         * "Recupero accessi pianificati/erogati" per questo PAI: sincronizza
         * da AnDIamo, poi ricarica SOLO gli accessi di questo idPai (non
         * uso il ricaricamento generico del mixin, che non applicherebbe
         * questo filtro).
         */
        onClickRecuperaAccessi() {
            let codiceAslDaUsare = this.codiceAsl || (this.dettaglio ? this.dettaglio.codiceAslAutore : null);
            if (!codiceAslDaUsare) {
                this.$bvToast.toast("Codice ASL non disponibile: apri questo PAI dal link nella lista", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.andiamoErogazioniPathResource;
            axios
                .get(link, {
                    params: {
                        idPai: this.idPai,
                        codiceAsl: codiceAslDaUsare,
                        stato: this.filtroAccessi.stato,
                        dataDa: this.filtroAccessi.dataDa,
                        dataA: this.filtroAccessi.dataA,
                    },
                })
                .then(() => {
                    this.closeShowModalLoading();
                    this.$bvToast.toast("Accessi aggiornati da AnDIamo", { title: "", variant: "success", solid: true });
                    this.loadAccessiPai();
                })
                .catch((error) => {
                    this.closeShowModalLoading();
                    this.$bvToast.toast("Errore: " + (error?.response?.data?.messaggio || error.message), { title: "Errore", variant: "danger", solid: true });
                });
        },
        loadAccessiPai() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.andiamoAccessiPathResource;
            axios
                .get(link, { params: { idPai: me.idPai } })
                .then((response) => {
                    me.accessiPai = response.data.data.list || [];
                    me.caricaPrestazioniPerAccessi();
                })
                .catch(() => {});
        },
        /**
         * Prestazioni REALI collegate agli accessi di questo PAI
         * (gesan_andiamo_accessi_prestazioni, per idAccesso) - stessa fonte
         * usata nella pagina Accessi standalone, non un derivato da
         * pai_attivita.
         */
        caricaPrestazioniPerAccessi() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.andiamoAccessiPrestazioniPathResource;
            axios
                .get(link, { params: { idPai: me.idPai } })
                .then((response) => {
                    let lista = response.data.data.list || [];
                    let mappa = {};
                    lista.forEach((p) => {
                        if (!mappa[p.idAccesso]) {
                            mappa[p.idAccesso] = [];
                        }
                        mappa[p.idAccesso].push(p);
                    });
                    me.prestazioniPerAccesso = mappa;
                })
                .catch(() => {});
        },
        onLoadDettaglioSuccess(response) {
            this.closeShowModalLoading();
            let data = response.data.data;
            this.dettaglio = data.dettaglio;
            this.attivita = data.attivita || [];
            this.careTeam = data.careTeam || [];
            this.diagnosi = data.diagnosi || [];
            this.eventi = data.eventi || [];
            this.andiamoCaricaPrestazioniErogatePerPai(this.idPai, this.onLoadPrestazioniErogateSuccess);
        },
        onLoadPrestazioniErogateSuccess(response) {
            this.closeShowModalLoading();
            this.erogazioniEsistenti = response.data.data || [];
        },
        onClickAggiornaDaAndiamo() {
            let codiceAslDaUsare = this.codiceAsl || (this.dettaglio ? this.dettaglio.codiceAslAutore : null);
            if (!codiceAslDaUsare) {
                this.$bvToast.toast("Codice ASL non disponibile: apri questo dettaglio dal link nella lista PAI", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            this.andiamoSincronizzaDettaglioPai(this.idPai, codiceAslDaUsare, false, () => {
                this.loadData();
            });
        },
        onClickRegistraErogazione() {
            let selezionate = this.prestazioniSelezionabili.filter((p) => p.selezionata);
            this.$refs.modalErogazione.apri(selezionate);
        },
        onErogazioneRegistrata() {
            this.loadData();
        },
    },
};
</script>

<style scoped>
.sa-siat-card-pratica {
    border: none;
    border-radius: 12px;
    margin-bottom: 25px;
    overflow: hidden;
}
.sa-siat-card-header-custom {
    background: #fff;
    border-bottom: 1px solid #edf2f7;
    padding: 15px 20px;
}
.sa-siat-label-pai {
    font-weight: bold;
    color: #7f8c8d;
    text-transform: uppercase;
    font-size: 0.85rem;
}
.sa-siat-data {
    color: #e83e8c;
}
.sa-siat-badge {
    display: inline-block;
    font-size: 0.9rem;
}
.sa-siat-badge-aperta {
    color: #07af07;
}
.sa-siat-badge-da-programmare {
    color: #e67e22;
}
</style>
